import { Component, ContentChild, Input } from "@angular/core";
import { IAdminPageItem } from "../admin-api-page/admin-api-page.component";
import { AdminApiModulePageToolbarDirective } from "./directives/admin-api-module-paage-toolbar.directive";

@Component({
    selector: "app-admin-api-module-page",
    templateUrl: "./admin-api-module-page.component.html",
    styleUrls: ["./admin-api-module-page.component.scss"],
    standalone: false
})
export class AdminApiModulePageComponent {
  @Input() displayModuleInHeader = true;
  @Input() module="";
  @Input() header = "";
  @Input() items: IAdminPageItem[] = [];

    @ContentChild(AdminApiModulePageToolbarDirective, { static: true })
    appAdminModulePageToolbar: AdminApiModulePageToolbarDirective;
}
